import { render, staticRenderFns } from "./Searcher.vue?vue&type=template&id=2bba858a&"
import script from "./Searcher.vue?vue&type=script&lang=js&"
export * from "./Searcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports